import { Link } from 'react-router-dom';

const STEPS = [
  { num: 1, title: 'Install the plugin', desc: 'Add the BonesPay gateway to your WooCommerce store.', link: '/api-docs' },
  { num: 2, title: 'Enter your API key', desc: 'Configure your API key in the plugin settings.', link: '/dashboard/settings' },
  { num: 3, title: 'Accept your first payment', desc: 'Enable the gateway and start receiving payments.', link: null },
];

export default function WelcomeCard() {
  return (
    <div
      className="rounded p-6"
      style={{ border: '1px solid var(--dash-border)', background: 'var(--dash-card)' }}
    >
      <h2 className="font-sans text-base font-medium mb-1" style={{ color: 'var(--dash-text-primary)' }}>
        Welcome to BonesPay
      </h2>
      <p className="font-sans text-sm mb-5" style={{ color: 'var(--dash-text-muted)' }}>
        Get started in three steps to begin accepting payments.
      </p>
      <div className="space-y-4">
        {STEPS.map((step) => (
          <div key={step.num} className="flex items-start gap-4">
            <div
              className="w-7 h-7 rounded-full flex items-center justify-center shrink-0"
              style={{ border: '1px solid var(--dash-avatar-border)', background: 'var(--dash-hover-bg)' }}
            >
              <span className="font-mono text-xs" style={{ color: 'var(--dash-text-muted)' }}>{step.num}</span>
            </div>
            <div className="pt-0.5">
              <p className="font-sans text-sm font-medium" style={{ color: 'var(--dash-text-secondary)' }}>{step.title}</p>
              <p className="font-sans text-xs mt-0.5" style={{ color: 'var(--dash-text-muted)' }}>{step.desc}</p>
              {step.link && (
                <Link
                  to={step.link}
                  className="font-mono text-xs transition-colors mt-1 inline-block"
                  style={{ color: 'var(--dash-text-muted)' }}
                >
                  Get started {'\u2192'}
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
